import React from "react";
var __jsx = React.createElement;
import stl from "./EmptySearchResult.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var EmptySearchResult = function EmptySearchResult(_ref) {
  var filters = _ref.filters;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/search.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("strong", {
    className: stl.title
  }, t("لا يوجد نتائج بحث مطابقة", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("p", null, t("حاول البحث عن الماركة والموديل واستخدام الفلاتر", {
    ns: "web_search"
  })), filters.length <= 4 && /*#__PURE__*/React.createElement("div", {
    className: stl.resetFiltersWrapper
  }, /*#__PURE__*/React.createElement("button", {
    className: stl.resetFiltersBtn,
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, t("إعادة تعيين جميع الفلاتر", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("strong", {
    className: stl.suggestions + " mb-1"
  }, t("نقترح عليك النتائج التالية", {
    ns: "web_search"
  })));
};
export default EmptySearchResult;